import React, { useState, useEffect, useContext } from "react";
import { View, Text, TextInput, StyleSheet, TouchableOpacity, Modal, useWindowDimensions, Platform, Linking } from "react-native";

import WooService from "../services/WooService";
import { GlobalContext } from "../context/GlobalContext";
import { CartContext } from "../context/CartContext";
import { PaymentMethodsContext } from "../context/PaymentMethodsContext";

import PaymentMethodsElement from "../components/PaymentMethodsElement";
import CartElement from "../components/CartElement";
import Config from "../config/Config";
import PrintOrderService from "../services/PrintOrderService";

// import SatService from "../services/SatService";

const config = new Config();

const TEST_VERSION = false;
const IDENTIFIER_STRING = "NOME";
const IDENTIFIER_PLACEHOLDER = "Informe seu nome";
const IDENTIFIER_TYPE = "text";
const PAYMENT_CONTROL = true;
const PAYMENT_SUCCESS = 0;
//const DEFAULT_PAYMENT_ID = PAYMENT_CONTROL && config.BUILD_PRODUCT !== config.PEDSEGURO_INDOOR ? "" : config.OPEN_PAYMENT;
//const DEFAULT_PAYMENT_NAME = PAYMENT_CONTROL && config.BUILD_PRODUCT !== config.PEDSEGURO_INDOOR ? "" : "Consumo no local";
const DEFAULT_PAYMENT_ID = PAYMENT_CONTROL && config.BUILD_PRODUCT !== config.PEDSEGURO_INDOOR ? 0 : config.OPEN_PAYMENT;
const DEFAULT_PAYMENT_NAME = PAYMENT_CONTROL && config.BUILD_PRODUCT !== config.PEDSEGURO_INDOOR ? "Selecione a forma de pagamento" : "Consumo no local";

const WIDTH_TRESHOLD = 640;

const CheckoutScreen = ({ navigation }) => {
    const [tableId, setTableId] = useState();
    const [customerName, setCustomerName] = useState(null);
    const [customerNotes, setCustomerNotes] = useState("");
    const [currentPayment, setCurrentPayment] = useState({id: DEFAULT_PAYMENT_ID, name: DEFAULT_PAYMENT_NAME});
    const [modalVisible, setModalVisible] = useState(false);
    const [confirmModalVisible, setConfirmModalVisible] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [newOrderId, setNewOrderId] = useState();

    const wooService = new WooService();

    const { cart, clearCart, emptyCart, getCartTotal } = useContext(CartContext);
    const { id, setId, customer, setCustomer, printers, elginPayService } = useContext(GlobalContext);
    const { paymentMethods } = useContext(PaymentMethodsContext);
    const { width, height } = useWindowDimensions();

    useEffect(() => {
        setTableId(config.USE_TABLE ? id : 99);
        setCustomerName(customer);
    }, []);

    const checkSat = async () => {
        /*
        const satService = new SatService();
        satService.statusOperacional("123456789");

        let actualEvent = DeviceEventEmitter.addListener('eventStatusSat', event => {
            console.log("statusSatReturn.: ", event);
        });

        setTimeout(() => {
            actualEvent.remove();
            console.log("Event removed");
        }, 5000);
        */
        return;
    }

    const successOrder = async (url) => {
        setConfirmModalVisible(false);
        setModalVisible(false);
        if (url) {
alert("URL: ", url);
            await Linking.openURL(url);
        }
        navigation.navigate("Categories", { navigationAction: "NEW_ORDER" });
    }

    const getPaymentLink = async () => {
        /* TODO */
        /* Get payment link for order and navigate to URL */
alert("order id: ", newOrderId);
        const paymentLink = await wooService.getPaymentLink(newOrderId);
alert("PL: ", paymentLink);
        successOrder(paymentLink);
    }

    const setChangedTable = (changedId) => {
        setTableId(changedId);
        setId(changedId);
    }

    const setChangedName = (name) => {
        setCustomerName(name);
        setCustomer(name);
    }

    const submitOrder = async () => {
        console.log("Current payment method: ", currentPayment);
        console.log("Platform: ", Platform.OS);

        if (tableId > 0 && customerName !== null && customerName.length > 0) {
            if (currentPayment.id) {
                let orderId = null;
                try {
                    let response = PAYMENT_SUCCESS;
                    if (config.BUILD_PRODUCT === config.CONTROL_CENTER_ELGINPAY && [config.CREDIT_CARD_ELGIN, config.DEBIT_CARD_ELGIN].includes(currentPayment.id)) {
                        response = await elginPayService.doElginPay(currentPayment.id === config.CREDIT_CARD_ELGIN ? 'credit' : 'debit', getCartTotal());
                    }
                    if (response === PAYMENT_SUCCESS) {
                        const isPaid = (currentPayment.id !== config.OPEN_PAYMENT);
                        setModalMessage('Aguarde. Enviando pedido...');
                        setModalVisible(true);
                        response = await wooService.submitOrder(cart, tableId, customerName, customerNotes, currentPayment, isPaid);
                        orderId = (response.data && response.data.id) ? response.data.id : null;
                        if (orderId) {
                            setNewOrderId(orderId);
                            /*
                            if ([config.CONTROL_CENTER_M10, config.CONTROL_CENTER_ELGINPAY].includes(config.BUILD_PRODUCT)) {
                                try {
                                    const printOrderService = new PrintOrderService();
                                    printOrderService.printIndoorOrder(orderId, customerName, tableId, cart.items, customerNotes);
                                }
                                catch(error) {
                                    console.log("Print error: ", error);
                                    alert(JSON.stringify(error));
                                }
                            }
                            */
                            setModalMessage('Pedido enviado com sucesso!');
                            setConfirmModalVisible(true);
                        } else {
                            setModalVisible(false);
                            console.log("Falha ao criar pedido.");
                            alert("Falha ao criar pedido.");
                        }
                    }
                }
                catch(error) {
                    setModalVisible(false);
                    console.log(error);
                    // alert(JSON.stringify(error));
                }
                if (orderId) {
                    clearCart();
                    // navigation.navigate("Categories", { navigationAction: "NEW_ORDER" });
                }
            } else {
                alert("Por favor, selecione a forma de pagamento");
            }
        } else {
            alert("Por favor, preencha a mesa e o nome e tente novamente");
        }
    }

    // Portrait proportion (section1/section2): 7/5 (12)
    // Landscape proportion (section1/section2): 4/3 (7)
    const portrait = (width < WIDTH_TRESHOLD);
    const section1Height = Math.trunc(portrait ? height * 7/12 : height);
    const section2Height = portrait ? height - section1Height - 100 : height - 60;

    return (
        <View style={portrait ? styles.verticalLayout : styles.horizontalLayout}>
            <Modal
                animationType="fade"
                transparent={true}
                visible={modalVisible}
                // If using react-native Modal implementation, change "onDismiss" to "onRequestClose"
                onDismiss={() => {
                    // alert("Pedido enviado!");
                }}>
                <View style={styles.modalView}>
                    <Text style={styles.modalText}>{modalMessage}</Text>
                    {confirmModalVisible && 
                        <View style={{marginTop: 30}}>
                            {newOrderId && (0 === 1) &&
                                <TouchableOpacity style={styles.buttons} onPress={() => getPaymentLink()}>
                                    <Text style={styles.buttonText}>Pagar agora</Text>
                                </TouchableOpacity>
                            }
                            <TouchableOpacity style={styles.buttons} onPress={() => successOrder(false)}>
                                <Text style={styles.buttonText}>OK</Text>
                            </TouchableOpacity>
                        </View>
                    }
                </View>     
            </Modal>
            <View style={{flex: portrait ? 7 : 4, marginTop: 10}}>
                {config.USE_TABLE &&
                    <View style={styles.fieldsRow}>
                        <Text style={styles.label}>MESA</Text>
                        <TextInput
                            style={[styles.textInput, {editable: config.BUILD_PRODUCT !== config.PEDSEGURO_INDOOR}]}
                            onChangeText={setChangedTable}
                            value={tableId}
                            keyboardType="numeric"
                            placeholder="Informe a mesa"
                        />
                    </View>
                }
                <View style={styles.fieldsRow}>
                    <Text style={styles.label}>{IDENTIFIER_STRING}</Text>
                    <TextInput
                        style={styles.textInput}
                        onChangeText={setChangedName}
                        value={customerName}
                        keyboardType={IDENTIFIER_TYPE}
                        placeholder={IDENTIFIER_PLACEHOLDER}
                    />
                </View>
                <View style={styles.fieldsRow}>
                    <Text style={styles.label}>OBS</Text>
                    <TextInput
                        style={styles.textInput}
                        onChangeText={setCustomerNotes}
                        value={customerNotes}
                        placeholder='Ex: Gelo e limão no refrigerante'
                    />
                </View>
                {PAYMENT_CONTROL && config.BUILD_PRODUCT !== config.PEDSEGURO_INDOOR &&
                    <View style={{flexGrow: 1}}>
                        <Text style={[styles.label, styles.paymentLabel]}>FORMA DE PAGAMENTO</Text>
                        <PaymentMethodsElement
                            paymentMethods={paymentMethods}
                            currentPayment={currentPayment}
                            setCurrentPayment={setCurrentPayment}>
                        </PaymentMethodsElement>
                    </View>
                }
            </View>
            <View style={{ flex: portrait ? 5 : 3, justifyContent: 'flex-start', backgroundColor: config.SECTION2_COLOR }}>
                <CartElement action={'create'} maxHeight={section2Height - 90} hideTitle={portrait}/>
                {(!emptyCart()) &&
                    <TouchableOpacity style={styles.buttons} onPress={() => submitOrder()}>
                        <Text style={styles.buttonText}>Enviar Pedido</Text>
                    </TouchableOpacity>
                }
                {TEST_VERSION &&
                    <TouchableOpacity style={styles.buttons} onPress={() => checkSat()}>
                        <Text style={styles.buttonText}>Status do SAT</Text>
                    </TouchableOpacity>
                }
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    verticalLayout: {
        flexDirection: 'column',
        flex: 1
    },
    horizontalLayout: {
        flexDirection: 'row',
        flex: 1
    },
    orderTitle: {
        fontSize: 18,
        marginBottom: 10
    },
    fieldsRow: {
        flexDirection: 'row', alignItems: 'center'
    },
    label: {
        marginLeft: 15,
        fontSize: 18,
        fontWeight: "bold"
    },
    paymentLabel: {
        marginBottom: 10
    },
    modalView: {
        justifyContent: "center",
        alignItems: "center",
        alignSelf: "center",
        marginTop: 100,
        backgroundColor: "white",
        borderRadius: 20,
        paddingVertical: 120,
        paddingHorizontal: 70,
        shadowColor: "#000",
        shadowOffset: {
          width: 0,
          height: 2
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5
    },
    modalText: {
        fontSize: 16,
        fontWeight: "bold"
    },
    textInput: {
        flexGrow: 1,
        height: 50,
        margin: 12,
        fontSize: 16,
        borderWidth: 1,
        borderRadius: 10,
        padding: 10,
    },
    customerNotes: {
        textAlignVertical: 'top'
    },
    buttons: {
        backgroundColor: '#965E11',
        width: 160,
        marginVertical: 10,
        padding: 10,
        borderRadius: 10,
        alignSelf: 'center'
    },
    buttonText: {
        fontSize: 18,
        fontWeight: 'bold',
        alignSelf: 'center',
        color: 'white'
    }
});

export default CheckoutScreen;

